import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const usePackageReducer = () => useSelector((state: ApplicationState) => state.package);
